import React, { useContext } from 'react';
import { RewardsContextProvider } from '../../context/RewardsContext/RewardsContext';
import { FlowContext } from '../../core/flow-engine';

const SummitRewards = ({ children }) => {
  const { appState } = useContext(FlowContext);
  const {
    store: { amount = 0, summitData = {} }
  } = appState;

  const { assetTierID = 0, totalAssetBalanceAmount = 0 } = summitData;

  return (
    <RewardsContextProvider
      initialTotalAmount={amount}
      initialTier={assetTierID}
      initialHouseholdBalance={totalAssetBalanceAmount}>
      {children}
    </RewardsContextProvider>
  );
};

export default SummitRewards;
